import {
    AddQuestionsActionsName,
    ClearSelectedQuestionDetails as ClearSelectedQuestionDetailsType,
    FetchSelectedQuestionDetails as FetchSelectedQuestionDetailsType,
    SetSelectedQuestionDetails as SetSelectedQuestionDetailsType,
    SetSavedLayout as SetSavedLayoutType,
} from './types';

export const fetchSelectedQuestionDetails = (stimulusContentRevisionId: number): FetchSelectedQuestionDetailsType => ({
    type: AddQuestionsActionsName.FETCH_QUESTION_DETAILS,
    stimulusContentRevisionId,
});

export const setSelectedQuestionDetails = (textContent: string, 
    objectType: string, 
    title: string, 
    questionContentItemId: number, 
    stimulusContentRevisionId: number):
SetSelectedQuestionDetailsType => ({
    type: AddQuestionsActionsName.SET_SELECTED_QUESTION_DETAILS,
    textContent,
    objectType,
    title,
    questionContentItemId,
    stimulusContentRevisionId,
});

export const clearSelectedQuestionDetails = (): ClearSelectedQuestionDetailsType => ({
    type: AddQuestionsActionsName.CLEAR_QUESTION_DEATILS,
});

export const setSavedLayout = (savedLayout: string | null): SetSavedLayoutType => ({
    type: AddQuestionsActionsName.SET_SAVED_LAYOUT,
    savedLayout,
});

export type ActionTypes =
    | FetchSelectedQuestionDetailsType
    | SetSelectedQuestionDetailsType
    | ClearSelectedQuestionDetailsType
    | SetSavedLayoutType;
